"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "fagagna": {
    "32739845": [{
      "hkey": "c1385794",
      "slug": "madrisio-battaglia-san-giovanni-in-colle",
      "name": "Madrisio-Battaglia-San Giovanni in Colle",
      "primary": true,
      "skipSearch": false
    }],
    "battaglia": [{
      "hkey": "c1385794",
      "slug": "madrisio-battaglia-san-giovanni-in-colle",
      "name": "Madrisio-Battaglia-San Giovanni in Colle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "fagagna"
    }],
    "0a1f1e11": [{
      "hkey": "c1385794",
      "slug": "madrisio-battaglia-san-giovanni-in-colle",
      "name": "Madrisio-Battaglia-San Giovanni in Colle",
      "primary": true,
      "skipSearch": false
    }],
    "madrisio": [{
      "hkey": "c1385794",
      "slug": "madrisio-battaglia-san-giovanni-in-colle",
      "name": "Madrisio-Battaglia-San Giovanni in Colle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;